module.exports = __webpack_public_path__ + "officialStatic/img/trusteeshipText.19d15b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeshipText.png
// module id = LkQ1
// module chunks = 0